import React, { useState } from "react";
import PropTypes from "prop-types";

import { Box, Typography } from "@mui/material";
import InputField from "./InputField";
import ColorPickerDialog from "./ColorPickerDialog";

const HighlightColorSelector = ({ organization, onOrganizationChange }) => {
  const [openColorPicker, setOpenColorPicker] = useState(false);
  
  const handleChange = ({ target: { value } }) => {
    const newOrganization = {
      ...organization,
      highlight_color: value,
    };
    onOrganizationChange(newOrganization);
  };

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Highlight Color
        </Typography>

        <InputField
          highlight_color={organization.highlight_color}
          openColorPicker={() => setOpenColorPicker(true)}
          onChange={handleChange}
        />

        <ColorPickerDialog
          open={openColorPicker}
          onClose={() => setOpenColorPicker(false)}
          onChange={handleChange}
          highlightColor={organization.highlight_color}
        />
      </Box>
    </>
  );
};

HighlightColorSelector.propTypes = {
  organization: PropTypes.object,
  onOrganizationChange: PropTypes.func,
};

export default HighlightColorSelector;
